import React from 'react'
import { useParams, Link } from 'react-router-dom'
import { useSelector } from 'react-redux'
import man1 from '../assests/gallery/Manimuthar-Falls-2.webp'
import man2 from '../assests/gallery/Papanasam_Waterfall.jpg'
import temple from '../assests/gallery/Old-Temple-Tirunelveli.webp'
import relax from '../assests/gallery/destinations-to-relax-with-family-in-tamil-nadu.avif'
import tiger from '../assests/gallery/Tiger-Reserve-1.webp'

export default function TripDetails(){
  const { slug } = useParams()
  const trip = useSelector(s => s.app.trips.find(t => t.slug === slug))

  if(!trip) return (
    <main className="container"><h1>Trip not found</h1><p>Return to <Link to="/explore">Explore</Link></p></main>
  )

  // Special layout for Kanyakumari 3D/2N
  if(trip.slug === 'kanyakumari'){
    return (
      <main>
        <section className="hero" style={{backgroundImage:`url(${relax})`, backgroundSize:'cover', backgroundPosition:'center'}}>
          <div className="hero-overlay" />
          <div className="container hero-inner">
            <h1>{trip.title}</h1>
            <p className="lead">Where three oceans meet — Vivekananda Rock, historic forts, sacred temples and coastal splendor at India's southernmost tip.</p>
            <div className="hero-cta">
              <a className="btn whatsapp" href={`https://wa.me/7010690812?text=${encodeURIComponent('I am interested in ' + trip.title)}`} target="_blank" rel="noopener">Enquire on WhatsApp</a>
            </div>
          </div>
        </section>

        <main className="container">
          <section className="card" style={{marginTop:'-2.5rem'}}>
            <h2>Overview</h2>
            <p>This 3 days / 2 nights journey immerses you in Kanyakumari — where the Arabian Sea, Bay of Bengal, and Indian Ocean converge. Experience iconic spiritual sites (Vivekananda Rock, Kumari Amman Temple), historic monuments (Vattakottai Fort, Gandhi Memorial), and the architectural marvels of Kerala's border region (Padmanabhapuram Palace, Mathur Aqueduct).</p>
            <p><strong>Recommended stay:</strong> Kanyakumari town for easy access to all attractions.</p>
          </section>

          <section className="card">
            <h2>Itinerary</h2>
            <div className="grid" style={{gridTemplateColumns:'1fr',gap:'.75rem'}}>
              <article>
                <h3>Day 1 — The Iconic Confluence & Coastal Forts</h3>
                <ul>
                  <li><strong>Morning — Arrival & Check-in:</strong> Arrive in Kanyakumari via rail or road. Check into your hotel.</li>
                  <li><strong>11:00 AM — Vivekananda Rock & Thiruvalluvar Statue:</strong> Ferry from mainland jetty. Visit the spiritual memorial and the 133-ft statue of poet Thiruvalluvar.</li>
                  <li><strong>1:30 PM — Lunch & Gandhi Memorial:</strong> Return to mainland for lunch. Visit the Gandhi Memorial Mandapam where Mahatma Gandhi's ashes were kept.</li>
                  <li><strong>4:00 PM — Vattakottai Fort:</strong> Drive 6 km northeast to this unique coastal circle fort. Panoramic views of Western Ghats and sea.</li>
                  <li><strong>Evening — Sunset & Dinner:</strong> Witness the breathtaking sunset at Triveni Sangam. Enjoy local seafood dinner.</li>
                </ul>
              </article>

              <article>
                <h3>Day 2 — Royal History & Waterfalls</h3>
                <ul>
                  <li><strong>Morning — Sunrise & Kumari Amman Temple:</strong> Witness sunrise at Triveni Sangam. Seek blessings at the ancient Kumari Amman Temple.</li>
                  <li><strong>10:00 AM — Padmanabhapuram Palace:</strong> Drive 1.5 hours to Thuckalay. Explore this magnificent 16th-century wooden palace, former capital of Travancore. (Closed Mondays)</li>
                  <li><strong>1:30 PM — Lunch & Thirparappu Waterfalls:</strong> Have lunch near palace. Visit Thirparappu Waterfalls — artificial waterfall with a pool for refreshing dip.</li>
                  <li><strong>4:30 PM — Mathur Hanging Trough (Aqueduct):</strong> Visit this engineering marvel, one of Asia's longest trough bridges. Scenic views of river below.</li>
                  <li><strong>Evening — Local Markets:</strong> Return to Kanyakumari. Explore local markets for seashell crafts and souvenirs.</li>
                </ul>
              </article>

              <article>
                <h3>Day 3 — Spiritual Stops & Departure</h3>
                <ul>
                  <li><strong>Morning — Suchindram Temple:</strong> Check out from hotel. Drive 12 km to Suchindram to visit this temple with unique 'Trimurti' idol and massive Hanuman statue.</li>
                  <li><strong>11:00 AM — Chothavilai or Muttom Beach:</strong> Visit one of the quieter local beaches for a peaceful coastal experience before departure.</li>
                  <li><strong>1:00 PM — Lunch:</strong> Enjoy a final South Indian meal.</li>
                  <li><strong>Afternoon — Departure:</strong> Proceed to Kanyakumari Junction or Trivandrum Airport (76 km) for onward journey.</li>
                </ul>
              </article>
            </div>
          </section>

          <section className="card">
            <h2>Highlights</h2>
            <ul>
              <li><strong>Three-Ocean Confluence:</strong> Unique geographical point where three seas meet, visible from Vivekananda Rock and Sangam Point.</li>
              <li><strong>Spiritual Gateway:</strong> Vivekananda Rock, Kumari Amman Temple, and Suchindram Temple offer peaceful meditation and pilgrimage experiences.</li>
              <li><strong>Historic Monuments:</strong> Gandhi Memorial, Vattakottai Fort, and Padmanabhapuram Palace tell stories of India's heritage.</li>
              <li><strong>Natural Wonders:</strong> Thirparappu Waterfalls and Mathur Aqueduct showcase nature and engineering prowess.</li>
              <li><strong>Coastal Beauty:</strong> Pristine beaches and stunning sunset views over the Arabian Sea.</li>
            </ul>
          </section>

          <section className="card">
            <h2>Photos</h2>
            <div className="gallery">
              <img src={relax} alt="Kanyakumari Coastline" />
              <img src={temple} alt="Temple Architecture" />
              <img src={man1} alt="Natural Landscape" />
              <img src={tiger} alt="Scenic Views" />
            </div>
          </section>

          <div style={{marginTop: '1rem'}}>
            <a className="btn whatsapp" href={`https://wa.me/7010690812?text=${encodeURIComponent('I am interested in ' + trip.title)}`} target="_blank" rel="noopener">Enquire on WhatsApp</a>
            <Link style={{marginLeft: '1rem'}} className="btn" to="/explore">Back to Explore</Link>
          </div>
        </main>
      </main>
    )
  }

  // Special layout for Tenkasi & Kutralam 3D/2N
  if(trip.slug === 'tenkasi-kutralam'){
    return (
      <main>
        <section className="hero" style={{backgroundImage:`url(${man2})`, backgroundSize:'cover', backgroundPosition:'center'}}>
          <div className="hero-overlay" />
          <div className="container hero-inner">
            <h1>{trip.title}</h1>
            <p className="lead">Medicinal waterfalls, ancient temples and Kerala eco-tourism — relax and rejuvenate in the Spa of the South.</p>
            <div className="hero-cta">
              <a className="btn whatsapp" href={`https://wa.me/7010690812?text=${encodeURIComponent('I am interested in ' + trip.title)}`} target="_blank" rel="noopener">Enquire on WhatsApp</a>
            </div>
          </div>
        </section>

        <main className="container">
          <section className="card" style={{marginTop:'-2.5rem'}}>
            <h2>Overview</h2>
            <p>This 3 days / 2 nights plan immerses you in Kutralam and Tenkasi—known as the "Spa of the South" for the medicinal properties of its waterfalls. Visit world-class natural water therapies, ancient temples, and a first-of-its-kind eco-tourism destination.</p>
            <p><strong>Recommended stay:</strong> Kutralam or Tenkasi for central access to all attractions.</p>
          </section>

          <section className="card">
            <h2>Itinerary</h2>
            <div className="grid" style={{gridTemplateColumns:'1fr',gap:'.75rem'}}>
              <article>
                <h3>Day 1 — Arrival & The Main Waterfalls Circuit</h3>
                <ul>
                  <li><strong>Morning — Arrival & Check-in:</strong> Arrive at Tenkasi Junction. Transfer to Kutralam hotel.</li>
                  <li><strong>10:00 AM — Kutralam Main Falls (Peraruvi):</strong> Head to the most famous falls with medicinal properties. Best time for a relaxed bath before crowds.</li>
                  <li><strong>1:00 PM — Lunch & Rest:</strong> Enjoy local South Indian cuisine. Rest at hotel.</li>
                  <li><strong>4:00 PM — Five Falls (Aintharuvi) & Temple:</strong> Visit the unique Five Falls and the adjacent Kutralanathar Temple before sunset.</li>
                  <li><strong>Evening — Market & Dinner:</strong> Stroll through Kutralam market and enjoy dinner.</li>
                </ul>
              </article>

              <article>
                <h3>Day 2 — Temples, Dams & Eco-Tourism</h3>
                <ul>
                  <li><strong>Morning — Kasi Viswanathar Temple:</strong> Drive to Tenkasi to visit the architecturally significant Kasi Viswanathar Temple ("Kasi of the South").</li>
                  <li><strong>11:00 AM — Thenmala Eco-Tourism:</strong> Scenic drive to Kerala border. Explore India's first planned eco-tourism destination with adventure zones, Kallada Dam and Shenduruney Wildlife Sanctuary boating.</li>
                  <li><strong>1:30 PM — Lunch:</strong> Enjoy lunch at eco-park cafes or head back toward Tenkasi.</li>
                  <li><strong>3:30 PM — Old Courtallam Falls:</strong> Visit the quieter Old Courtallam Falls for a natural bathing experience away from crowds.</li>
                  <li><strong>Evening — Rest & Dinner:</strong> Return to hotel for second overnight stay.</li>
                </ul>
              </article>

              <article>
                <h3>Day 3 — Manimuthar Falls & Departure</h3>
                <ul>
                  <li><strong>Morning — Manimuthar Waterfalls & Dam:</strong> Check out and drive to Manimuthar Falls in the Podhigai foothills. Refreshing dip and visit the large Manimuthar Dam for views.</li>
                  <li><strong>12:30 PM — Lunch:</strong> Have lunch near the dam area or en route.</li>
                  <li><strong>2:30 PM — Agasthiyar Falls (Optional):</strong> If time permits, visit Agasthiyar Falls and Papanasam Sivan Temple.</li>
                  <li><strong>Evening — Departure:</strong> Drop off at Tenkasi or Tirunelveli Junction for onward journey.</li>
                </ul>
              </article>
            </div>
          </section>

          <section className="card">
            <h2>Why Tenkasi & Kutralam?</h2>
            <ul>
              <li>Medicinal waterfalls: Kutralam's falls flow through herb-rich forests, believed to have natural healing properties.</li>
              <li>Temples: Kasi Viswanathar, Kutralanathar, and Papanasam Sivan temples offer spiritual and architectural significance.</li>
              <li>Eco-tourism: Thenmala is India's first planned eco-destination with adventure activities and wildlife viewing.</li>
              <li>Relaxation: Ideal for wellness retreats, water therapy, and nature immersion.</li>
            </ul>
          </section>

          <section className="card">
            <h2>Photos</h2>
            <div className="gallery">
              <img src={man1} alt="Manimuthar Falls" />
              <img src={man2} alt="Waterfalls" />
              <img src={temple} alt="Ancient Temple" />
              <img src={tiger} alt="Forest Reserve" />
              <img src={relax} alt="Scenic Views" />
            </div>
          </section>

          <div style={{marginTop: '1rem'}}>
            <a className="btn whatsapp-light" href={`https://wa.me/7010690812?text=${encodeURIComponent('I am interested in ' + trip.title)}`} target="_blank" rel="noopener">Enquire on WhatsApp</a>
            <Link style={{marginLeft: '1rem'}} className="btn" to="/explore">Back to Explore</Link>
          </div>
        </main>
      </main>
    )
  }

  // Special layout for Tirunelveli 2D/1N
  if(trip.slug === 'tirunelveli-2d1n'){
    return (
      <main>
        <section className="hero" style={{backgroundImage:`url(${man1})`, backgroundSize:'cover', backgroundPosition:'center'}}>
          <div className="hero-overlay" />
          <div className="container hero-inner">
            <h1>{trip.title}</h1>
            <p className="lead">A compact, soul-satisfying trip into the Agasthiyar belt — waterfalls, dams and cultural highlights.</p>
            <div className="hero-cta">
              <a className="btn whatsapp" href={`https://wa.me/7010690812?text=${encodeURIComponent('I am interested in ' + trip.title)}`} target="_blank" rel="noopener">Enquire on WhatsApp</a>
            </div>
          </div>
        </section>

        <main className="container">
          <section className="card" style={{marginTop:'-2.5rem'}}>
            <h2>Overview</h2>
            <p>This 2 days / 1 night plan is optimised for travellers using a dedicated cab service for efficiency. You'll experience Agasthiyar and Manimuthar waterfall areas, scenic dams and the cultural heart of Tirunelveli.</p>
            <p><strong>Recommended stay:</strong> Ambasamudram or Kallidaikurichi for convenient access to attractions.</p>
          </section>

          <section className="card">
            <h2>Itinerary</h2>
            <div className="grid" style={{gridTemplateColumns:'1fr',gap:'.75rem'}}>
              <article>
                <h3>Day 1 — Arrival & The Agasthiyar Belt</h3>
                <ul>
                  <li><strong>Morning — Depart & Breakfast:</strong> Start around 7:30 AM. Quick breakfast (Idli/Dosa) in Tirunelveli or Ambasamudram.</li>
                  <li><strong>9:30 AM — Agasthiyar Falls:</strong> Arrive at Papanasam/Agasthiyar Falls. Note: pass a forest checkpost; carry ID. Enjoy the refreshing falls.</li>
                  <li><strong>12:30 PM — Papanasam Temple & Lunch:</strong> Visit Papanasam Sivan Temple and have lunch nearby (limited options beyond).</li>
                  <li><strong>2:30 PM — Karaiyar (Upper) Dam:</strong> Scenic drive on the ghat road. Great reservoir views between mountain ranges.</li>
                  <li><strong>5:30 PM — Check-in:</strong> Stay near Ambasamudram or Kallidaikurichi. Evening at leisure.</li>
                </ul>
              </article>

              <article>
                <h3>Day 2 — Manimuthar Falls & Local Culture</h3>
                <ul>
                  <li><strong>Morning — Manimuthar Waterfalls:</strong> Depart ~7:30 AM to reach early. Dip in the pond at the base of the falls.</li>
                  <li><strong>10:30 AM — Manimuthar Dam:</strong> Visit the dam — a picturesque spot for photos.</li>
                  <li><strong>12:30 PM — Lunch & Check-out:</strong> Lunch at a recommended local place on the way back.</li>
                  <li><strong>2:30 PM — Nellaiappar Temple:</strong> Return to Tirunelveli to visit the magnificent Nellaiappar Temple.</li>
                  <li><strong>3:30 PM — Thoranamalai Temple:</strong> Visit the hilltop Thoranamalai Temple for panoramic views and a peaceful atmosphere — a short serene stop for photos and reflection.</li>
                  <li><strong>4:30 PM — Local Market & Halwa:</strong> Stroll the market and pick up Tirunelveli Halwa before departure.</li>
                </ul>
              </article>
            </div>
          </section>

          <section className="card">
            <h2>Accommodation</h2>
            <p>We recommend Ambasamudram or Kallidaikurichi. Options like Hotel Ambai Grand or local lodges offer convenient access to waterfalls and dams.</p>
          </section>

          <section className="card">
            <h2>Practical Notes</h2>
            <ul>
              <li>Carry ID for forest checkposts at Agasthiyar/Manimuthar areas.</li>
              <li>Some roads are winding — a dedicated cab is ideal for comfort and timing.</li>
              <li>Limited dining options near reserves — plan lunch stops in Ambasamudram/Papanasam.</li>
            </ul>
          </section>

          <section className="card">
            <h2>Photos</h2>
            <div className="gallery">
              <img src={man1} alt="Manimuthar Falls" />
              <img src={man2} alt="Manimuthar Falls view" />
              <img src={temple} alt="Nellaiappar Temple" />
              <img src={relax} alt="Scenic drive" />
            </div>
          </section>

          <div style={{marginTop: '1rem'}}>
            <a className="btn whatsapp-light" href={`https://wa.me/7010690812?text=${encodeURIComponent('I am interested in ' + trip.title)}`} target="_blank" rel="noopener">Enquire on WhatsApp</a>
            <Link style={{marginLeft: '1rem'}} className="btn" to="/explore">Back to Explore</Link>
          </div>
        </main>
      </main>
    )
  }

  // Default fallback layout
  return (
    <main className="container">
      <h1>{trip.title}</h1>
      <p className="lead">Full itinerary and details for {trip.title}.</p>

      <section className="card">
        <h2>Overview</h2>
        <p>{trip.desc}</p>
      </section>

      <section className="card">
        <h2>Price</h2>
        <p>{trip.price}</p>
      </section>

      <div style={{marginTop: '1rem'}}>
        <a className="btn whatsapp-light" href={`https://wa.me/7010690812?text=${encodeURIComponent('I am interested in ' + trip.title)}`} target="_blank" rel="noopener">Enquire on WhatsApp</a>
        <Link style={{marginLeft: '1rem'}} className="btn" to="/explore">Back to Explore</Link>
      </div>
    </main>
  )
}
